<template>
  <NotFoundError>
    <template #title>Document non trouvé</template>

    <template #hat>
      <p class="text-h1">Le document auquel vous essayez d'accéder n'existe pas ou a été supprimé.</p>
    </template>

    <template #subtitle>
      <p></p>
    </template>

    <template #help>
      <p></p>
    </template>

    <template #btn-home>
      <PButton :to="{ name: 'form-update', params: { chrono: letterFile!.chronoNumber } }"> Parapheur </PButton>
    </template>
  </NotFoundError>
</template>

<script setup lang="ts">
import { useLetterFileStore } from "@/app/stores/letter-file.store.ts";
import { NotFoundError, PButton } from "@pasta/box-v2";
import { computed } from "vue";

const letterFileStore = useLetterFileStore();
const letterFile = computed(() => {
  return letterFileStore.getCurrent();
});
</script>
